export const upDownTriangleSymbol = function (x: number, y: number, w: number, h: number) {
  const cx = x + w / 2;
  return ['M', cx, y + h, 'L', x + w, y, 'L', x, y, 'Z'];
};

export const squareSymbol = function (x: number, y: number, w: number, h: number) {
  return ['M', x, y, 'L', x + w, y, 'L', x + w, y + h, 'L', x, y + h, 'Z'];
};

export const circleSymbol = function (x: number, y: number, w: number, h: number) {
  const cx = x + w / 2;
  const cy = y + h / 2;
  const r = Math.max(w, h) * 0.5;
  return ['M', cx + r, cy, 'A', r, r, 0, 1, 0, cx - r, cy, 'A', r, r, 0, 1, 0, cx + r, cy];
};

export const pentagonSymbol = function (x: number, y: number, w: number, h: number) {
  const cx = x + w / 2;
  const cy = y + h / 2;
  const r = Math.max(w, h) * 0.5;
  const angle = (2 * Math.PI) / 5;
  const points = [];
  for (let i = 0; i < 5; i++) {
    const px = cx + r * Math.cos(i * angle - Math.PI / 2);
    const py = cy + r * Math.sin(i * angle - Math.PI / 2);
    points.push(px, py);
  }
  return [
    'M',
    points[0],
    points[1],
    'L',
    points[2],
    points[3],
    'L',
    points[4],
    points[5],
    'L',
    points[6],
    points[7],
    'L',
    points[8],
    points[9],
    'Z',
  ];
};

export const diamondSymbol = function (x: number, y: number, w: number, h: number) {
  const cx = x + w / 2;
  const cy = y + h / 2;
  return ['M', cx, y, 'L', x + w, cy, 'L', cx, y + h, 'L', x, cy, 'Z'];
};

export function symbolPathToSvgString(
  symbolFn: (x: number, y: number, w: number, h: number) => (string | number)[],
  x = 0,
  y = 0,
  w = 16,
  h = 16,
): string {
  const SVG_PATH = 'svgpath:';
  const path = symbolFn(x, y, w, h);
  return (
    SVG_PATH +
    path
      .map((token) => (typeof token === 'number' ? Number(token.toFixed(3)).toString() : token))
      .join(' ')
      .trim()
  );
}
